export default __webpack_public_path__ + "static/media/Twitter.aa0fe85f.png";